import { Search, X } from 'lucide-react';
import { cn } from '#client/lib/cn';

interface SearchFilterProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string | undefined;
  className?: string | undefined;
}

export function SearchFilter({
  value,
  onChange,
  placeholder = 'Search',
  className,
}: SearchFilterProps) {
  return (
    <div className={cn('c-search', className)}>
      <Search className="c-search__icon" aria-hidden="true" />
      <input
        type="search"
        className="c-search__control"
        value={value}
        placeholder={placeholder}
        aria-label={placeholder}
        onChange={(event) => onChange(event.target.value)}
      />
      {value && (
        <button
          type="button"
          className="c-search__clear"
          onClick={() => onChange('')}
          aria-label="Clear search"
        >
          <X aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
